// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/quote.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { FilterGroup, PageRequest, PageResponse, SortSpec } from "./common_pb.js";
import { MatchMode } from "./work_item_pb.js";

/**
 * @generated from enum omnios.v1.QuoteSourceType
 */
export const QuoteSourceType = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.QuoteSourceType",
  [
    {no: 0, name: "QUOTE_SOURCE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "QUOTE_SOURCE_TYPE_MANUAL", localName: "MANUAL"},
    {no: 2, name: "QUOTE_SOURCE_TYPE_CASE", localName: "CASE"},
    {no: 3, name: "QUOTE_SOURCE_TYPE_STOREFRONT", localName: "STOREFRONT"},
    {no: 4, name: "QUOTE_SOURCE_TYPE_API", localName: "API"},
  ],
);

/**
 * @generated from message omnios.v1.Quote
 */
export const Quote = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Quote",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sales_rep_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "lines", kind: "message", T: QuoteLine, repeated: true },
    { no: 8, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "validity_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "valid_until", kind: "message", T: Timestamp },
    { no: 11, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "revision", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "source_type", kind: "enum", T: proto3.getEnumType(QuoteSourceType) },
    { no: 15, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "is_processing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.QuoteLine
 */
export const QuoteLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.QuoteLine",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateQuoteRequest
 */
export const CreateQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateQuoteRequest",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sales_rep_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "validity_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "source_type", kind: "enum", T: proto3.getEnumType(QuoteSourceType) },
    { no: 8, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetQuoteRequest
 */
export const GetQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetQuoteRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateQuoteRequest
 */
export const UpdateQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateQuoteRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "validity_days", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "sales_rep_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteQuoteRequest
 */
export const DeleteQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteQuoteRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListQuotesRequest
 */
export const ListQuotesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListQuotesRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "source_type", kind: "enum", T: proto3.getEnumType(QuoteSourceType) },
  ],
);

/**
 * @generated from message omnios.v1.ListQuotesResponse
 */
export const ListQuotesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListQuotesResponse",
  () => [
    { no: 1, name: "quotes", kind: "message", T: Quote, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.SetQuoteLinesRequest
 */
export const SetQuoteLinesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetQuoteLinesRequest",
  () => [
    { no: 1, name: "quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lines", kind: "message", T: QuoteLineInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.QuoteLineInput
 */
export const QuoteLineInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.QuoteLineInput",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SetQuoteLinesResponse
 */
export const SetQuoteLinesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetQuoteLinesResponse",
  () => [
    { no: 1, name: "quote", kind: "message", T: Quote },
  ],
);

/**
 * @generated from message omnios.v1.SendQuoteRequest
 */
export const SendQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SendQuoteRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AcceptQuoteRequest
 */
export const AcceptQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AcceptQuoteRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RejectQuoteRequest
 */
export const RejectQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RejectQuoteRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SubmitCounterOfferRequest
 */
export const SubmitCounterOfferRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SubmitCounterOfferRequest",
  () => [
    { no: 1, name: "quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "revised_lines", kind: "message", T: QuoteLineInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AcceptCounterOfferRequest
 */
export const AcceptCounterOfferRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AcceptCounterOfferRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ConvertQuoteToOrderRequest
 */
export const ConvertQuoteToOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConvertQuoteToOrderRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ConvertQuoteToOrderResponse
 */
export const ConvertQuoteToOrderResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConvertQuoteToOrderResponse",
  () => [
    { no: 1, name: "quote", kind: "message", T: Quote },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.QuoteLineReview
 */
export const QuoteLineReview = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.QuoteLineReview",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "raw_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "matched_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "matched_product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "parsed_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "parsed_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "selling_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "converted_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "unit_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "attrs", kind: "message", T: Struct },
    { no: 16, name: "reject_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ProcessQuoteRequest
 */
export const ProcessQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProcessQuoteRequest",
  () => [
    { no: 1, name: "quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mode", kind: "enum", T: proto3.getEnumType(MatchMode) },
  ],
);

/**
 * @generated from message omnios.v1.ListQuoteReviewsRequest
 */
export const ListQuoteReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListQuoteReviewsRequest",
  () => [
    { no: 1, name: "quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "triage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListQuoteReviewsResponse
 */
export const ListQuoteReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListQuoteReviewsResponse",
  () => [
    { no: 1, name: "reviews", kind: "message", T: QuoteLineReview, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ReviewQuoteReviewRequest
 */
export const ReviewQuoteReviewRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReviewQuoteReviewRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "matched_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ReviewQuoteReviewResponse
 */
export const ReviewQuoteReviewResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReviewQuoteReviewResponse",
  () => [
    { no: 1, name: "review", kind: "message", T: QuoteLineReview },
  ],
);

/**
 * @generated from message omnios.v1.BatchReviewQuoteReviewsRequest
 */
export const BatchReviewQuoteReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchReviewQuoteReviewsRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchReviewQuoteReviewsResponse
 */
export const BatchReviewQuoteReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchReviewQuoteReviewsResponse",
  () => [
    { no: 1, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchResearchQuoteReviewsRequest
 */
export const BatchResearchQuoteReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchResearchQuoteReviewsRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BatchResearchQuoteReviewsResponse
 */
export const BatchResearchQuoteReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchResearchQuoteReviewsResponse",
  () => [
    { no: 1, name: "researched", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchQuoteReviewAlternativesRequest
 */
export const SearchQuoteReviewAlternativesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchQuoteReviewAlternativesRequest",
  () => [
    { no: 1, name: "review_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "query_override", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "attribute_filters", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "category_filter", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "include_facets", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.FinalizeQuoteRequest
 */
export const FinalizeQuoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizeQuoteRequest",
  () => [
    { no: 1, name: "quote_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.FinalizeQuoteResponse
 */
export const FinalizeQuoteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizeQuoteResponse",
  () => [
    { no: 1, name: "quote", kind: "message", T: Quote },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lines_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

